<template>
  <div class="page">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img">
        <div class="top-banner-center">
          <!-- <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">资源池</div> -->
          <!-- <div class="btn-row wow animate__animated animate__zoomIn">
            <div class="btn">需求征集</div>
            <div class="btn">服务商入驻</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="module">
      <div class="module-title">国家级荣誉</div>
      <div class="honor-content">
        <div class="vertical-box">
          <div class="vertical-line"></div>
          <div class="vertical-text">NATIONAL HONOR</div>
        </div>
        <div class="honor-nav">
          <div class="trophy-box"></div>
          <div class="classify-list">
            <div :class="{'classify-item':true, 'active': countryParams.rollTypeSecond == item.code ? true:false }" v-for="item in classifyList" :key="item.uuid" @click="classifyCountrySelect(item.code)">{{item.name}}</div>
          </div>  
        </div>
        <el-empty :image-size="200" v-if="countryHonorList.length==0"></el-empty>
        <div  v-else  class="honor-list">
          <div :class="{'honor-item':true, 'active': (countryParams.rollTypeSecond == item.rollTypeSecond || countryParams.rollTypeSecond == '')? true:false}" v-for="item in countryHonorList" :key="item.uuid" @click="openDetail(item)">
            <div class="text-box">
              <div class="bg-year">{{item.year}}</div>
              <div class="title">{{item.rollName}}</div>
              <!-- <div class="introduction">奖项简介奖项简介奖项简介奖项简介奖项简介奖项奖项简介奖项奖项简介奖项奖项简介奖项...</div> -->
            </div>
            <div class="img-box"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="module-title">自治区级荣誉</div>
      <div class="honor-content">
        <div class="vertical-box">
          <div class="vertical-line"></div>
          <div class="vertical-text">NATIONAL HONOR</div>
        </div>
        <div class="honor-nav">
          <div class="trophy-box"></div>
          <div class="classify-list">
            <div :class="{'classify-item':true, 'active': provinceParams.rollTypeSecond == item.code ? true:false }" v-for="item in classifyList" :key="item.uuid" @click="classifyProvinceSelect(item.code)">{{item.name}}</div>
          </div>  
        </div>
        <el-empty :image-size="200" v-if="provinceHonorList.length==0"></el-empty>
        <div v-else class="honor-list">
          <div :class="{'honor-item':true, 'active': (provinceParams.rollTypeSecond == item.rollTypeSecond || provinceParams.rollTypeSecond == '')? true:false}" v-for="item in provinceHonorList" :key="item.uuid" @click="openDetail(item)">
            <div class="text-box">
              <div class="bg-year">{{item.year}}</div>
              <div class="title">{{item.rollName}}</div>
            </div>
            <div class="img-box"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-btn" @click="goMorePage">更多荣誉</div>
    <el-dialog
      title=""
      :visible.sync="detailVisible"
      width="1210px"
      custom-class="detail-dialog"
      center>
      <el-table
        :data="dataVoList"
        style="width: 100%;"
        class="detail-table">
        <el-table-column :label="detailData.rollName" align="center" class="one-head" label-class-name="title-th">
          <el-table-column
            :prop="item.code"
            :label="item.name"
            align="center"
            label-class-name="subtitle-th"
            v-for="item in titleList"
            :width="getColumnWidth(item.code)"
            :key="item.code">
          </el-table-column>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="btn" @click="detailVisible = false">确定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getCount,
  getServiceSortCount,
  getServiceCount,
  getServiceIcon
} from "../../utils/interface";
import { securityService, dictionaryTreeList, honorQuery, honorDetail } from "@/utils/honorApi";
export default {
  name: "",
  components: { },
  props: {},
  data() {
    return {
      classifyList: [],
      countryHonorList: [],
      provinceHonorList: [],
      countryParams: {
        rollType: '国家级',
        rollTypeSecond: '',
        current: 1,
        pageSize: 16,
      },
      provinceParams: {
        rollType: '自治区级',
        rollTypeSecond: '',
        current: 1,
        pageSize: 16,
      },
      headerBgUrl: "",
      title: "",
      timer: null,
      detailVisible: false,
      dialogLoading: false,
      detailData: {
        rollName: ''
      },
      titleList: [],
      dataVoList: [],
      columnWidths: {},
    };
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  created() {
    this.getClassify();
    // this.getOptionsData();
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    classifyCountrySelect(code) {
      this.countryParams.rollTypeSecond = code;
      this.countryHonorList = this.sortByRollTypeSecond(this.countryHonorList, code);
    },
    classifyProvinceSelect(code) {
      this.provinceParams.rollTypeSecond = code;
      this.provinceHonorList = this.sortByRollTypeSecond(this.provinceHonorList, code);
    },    
    sortByRollTypeSecond(list, targetCode) {
      return list.sort((a, b) => {
        const aIsTarget = a.rollTypeSecond === targetCode;
        const bIsTarget = b.rollTypeSecond === targetCode;

        // 1. 目标项优先
        if (aIsTarget && !bIsTarget) return -1; // a 在前
        if (!aIsTarget && bIsTarget) return 1;  // b 在前

        // 2. 同属目标 or 同属非目标 → 按 year 倒序
        return b.year - a.year;
      });
    },
    getCountryHonorList() {
      let params = {
        rollType: '国家级',
        current: 1,
        pageSize: 999,
      }
      honorQuery(params).then(res => {
        console.log('getCountryHonorList res', res)
        if (res.list.length > 0) {
          this.countryHonorList = res.list.sort((a, b) => b.year - a.year);;
        }
      });
    },
    getProvinceHonorList() {
      let params = {
        rollType: '自治区级',
        current: 1,
        pageSize: 999,
      }
      honorQuery(params).then(res => {
        console.log('getProvinceHonorList res', res)
        if (res.list.length > 0) {
          this.provinceHonorList = res.list.sort((a, b) => b.year - a.year);
        }
      });
    },
    async getClassify() {
      const securityResponse = await securityService({});
      const found = securityResponse.find(item => item.code === 'honorCategory');
      const uuid = found ? found.uuid : null;
      if (!uuid) {
        return [];
      }
      this.classifyList = await dictionaryTreeList({ serviceUuid: uuid, current: 1, pageSize: 100 });
      this.getCountryHonorList();
      this.getProvinceHonorList();
    },
    goMorePage() {
       this.$router.push("/honorList");
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    async openDetail(item) {
      if (this.dialogLoading) {
        this.$message.info('数据加载中');
        return;
      }
      this.dialogLoading = true;
      await honorDetail(item.uuid).then(res => {
        if (res.success) {
          console.log('res item', res);
          this.detailData = res.data.head;
          this.titleList = res.data.titleList || [];
          this.dataVoList = res.data.dataVoList || [];
          this.detailVisible = true;
        } else {
          this.$message.error(res.message || '查询失败');
          
        }
      }).finally(_ => {
        this.dialogLoading = false;
      });
      // this.updateColumnWidths();
    },
    getColumnWidth(code) {
      const map = {
        XH: 60,
        nf: 80,
        pc: 90,
      };
      // 只返回固定列的宽度，其他列不设 width
      return map[code] || undefined;
    },
    onClickLookMore() {},
  }
};
</script>
<style lang="less" scoped>
.page {
  position: relative;
  top: -80px;
  margin-bottom: -80px;
  padding-bottom: 30px;
  background: #F0F4FA;


  .top-banner-box {
    position: relative;
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url('~@/assets/image/honor_top_bg.png') no-repeat;
      background-size: cover;
      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }
      .btn-row {
        margin-left: 80px;
        // background-color: white;
        display: flex;  
        position: absolute;
        bottom: 45px;
        transition: all 0.2s;
      }
      .btn {
        margin-right: 15px;
        width: 166px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: normal;
        color: #3672F6;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.4);
        box-sizing: border-box;
        border: 1px solid #3672F6;
        cursor: pointer;
        user-select: none;
        &:first-child {
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #FFFFFF;
        }
      }
    }
  }


}

.module {
  width: 1300px;
  margin: 0 auto;
  color: #2B2B2B;
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
  }
  .honor-content {
    display: flex;
    // justify-content: space-between;
  }
  .vertical-box {
    flex-shrink: 0;
    position: relative;
    width: 38px;
    .vertical-line {
      position: relative;
      top: 118px;
      width: 1px;
      height: 463px;
      background-color: #CBCBCB;
      z-index: 1;
    }
    .vertical-text {
      position: relative;
      top: 408px;
      left: -22px;
      transform: translateY(-50%) rotate(-90deg);
      text-transform: uppercase;
      font-size: 28px;
      font-weight: 900;
      font-style: italic;
      color: #2B2B2B;
      opacity: 0.3;
      letter-spacing: 1px;
      white-space: nowrap;
      z-index: 2;
    }
  }
  .honor-nav {
    flex-shrink: 0;
    margin-right: 40px;
    padding: 34px 6px 10px;
    width: 270px;
    height: 1014px;
    box-sizing: border-box;
    background: url('~@/assets/image/honor_trophy_bg.png') no-repeat;
    background-size: cover;
    .trophy-box {
      width: 258px;
      height: 415px;
      background: url('~@/assets/image/honor_trophy.png') no-repeat;
      background-size: cover;
    }
    .classify-list {
      margin: 56px auto 0;
      width: fit-content;
      height: 508px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
          display: none; /* 隐藏滚动条 */
      }
    }
    .classify-item {
      margin-bottom: 55px;
      padding-top: 15px;
      width: 167px;
      height: 72px;
      background-image: url('~@/assets/image/honor_trophy_text.png');
      background-repeat: no-repeat;
      background-size: cover;
      font-size: 24px;
      font-weight: bold;
      color: #6A6A6A;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      &.active {
        background-image: url('~@/assets/image/honor_trophy_text_active.png');
        color: #2D50A1;
      }
    }
  }
  .honor-list {
    flex-grow: 1;
    padding: 60px 0 0;
    max-height: 896px;
    height: fit-content;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
    }
  }
  .honor-item {
    margin-right: 20px;
    margin-bottom: 27px;
    padding: 30px 24px 10px;
    position: relative;
    width: 466px;
    height: 182px;
    border-radius: 8px;
    opacity: 1;
    background: #EAEAEA;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 350;
    color: #BCBCBC;
    display: flex;
    cursor: pointer;
    &:nth-child(2n) {
      margin-right: 0;
    }
    .introduction {
      display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      -webkit-line-clamp: 2; /* 限制显示两行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .text-box {
      width: 288px;
      display: flex;
      flex-direction: column;
      .bg-year {
        font-family: YouSheBiaoTiHei;
        font-size: 72px;
        font-weight: 800;
        line-height: 1;
        letter-spacing: -0.09em;
        font-variation-settings: "opsz" auto;
        color: rgba(43, 43, 43, 0.25);
        opacity: 0.5;
      }
       .title {
        font-size: 24px;
        font-weight: bold;
        display: -webkit-box; /* 使用 WebKit 弹性盒子模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 2; /* 限制显示两行 */
        overflow: hidden; /* 隐藏超出内容 */
        text-overflow: ellipsis; /* 使用省略号 */
      }
    }
    .img-box {
      width: 154px;
      height: 97px;
      background-image: url('~@/assets/image/honor_item.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
    &.active {
      color: #2B2B2B;
      background: #FFFFFF;
      .img-box {
        background-image: url('~@/assets/image/honor_item_active.png');
      }
    }
    &:hover {
      background: #2D50A1;
      color: #fff;
      .img-box {
        background-image: url('~@/assets/image/honor_item_active.png');
      }
    }
  }
}
.more-btn {
      margin: 40px auto 0;
      width: 200px;
      height: 50px;
      border-radius: 4px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #2D50A1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2D50A1;
      font-size: 16px;
      font-weight: normal;
      cursor: pointer;
}
.btn {
  cursor: pointer;
}

/deep/ .el-dialog.detail-dialog {
  .el-table.detail-table {
    max-height: 500px;
    overflow: hidden;
    thead { 
      color: #2B2B2B;
    }
    th.subtitle-th {
      background: #f3f7ff;
      font-size: 18px;
      font-weight: normal;
    }
    th.title-th {
      background: #E0EBFF;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .el-table__body-wrapper.is-scrolling-none {
    max-height: 398px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;  /* 设置垂直滚动条的宽度 */
      // display: none; /* 隐藏滚动条 */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #d9d9d9; /* 滑块颜色 */
      border-radius: 2px; /* 滑块圆角 */
    }
  }
}

.dialog-footer {
  .btn {
    margin: 0 auto;
    width: 146px;
    height: 48px;
    border-radius: 4px;
    opacity: 1;
    background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 350;
    box-sizing: border-box;
  }
}

/deep/ .el-empty {
  margin: 0 auto;
}
/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/honor/index.vue